<template>
    <div class="modal modal-todo modal-follow-up-logs fade" tabindex="-1" role="dialog" ref="modal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Follow Up details</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="isLoadingData" class="text-center py-3">
                        <span class="spinner-border spinner-border-sm text-primary"></span> Loading...
                    </div>

                    <div v-else-if="logs.length === 0" class="text-muted text-center">
                        No follow-up logs found.
                    </div>

                    <div v-else class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                            <thead class="thead-light">
                                <tr>
                                    <th>Date</th>
                                    <th>Timezone</th>
                                    <th>Type</th>
                                    <th>Duration</th>
                                    <th>Comments</th>
                                    <th>Status</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(log, index) in logs" :key="index">
                                    <td v-html="log.formattedDate"></td>
                                    <td>{{ log.timezone || '-' }}</td>
                                    <td>{{ log.type || '-' }}</td>
                                    <td>{{ formatDuration(log.duration) || '-' }}</td>
                                    <td>{{ log.reason || '-' }}</td>
                                    <td class="text-capitalize">{{ log.status || '-' }}</td>
                                    <td>
                                        <span v-if="log.status === 'rejected'">
                                            {{ log.rejected_follow_up_notes || '-' }}
                                        </span>
                                        <span v-else>
                                            {{ log.notes || '-' }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getFollowUpLogs } from '../../../services/api/to-do';
import { formatDuration } from '../../../utils/helpers';

export default {
    name: 'FollowUpLogsModal',
    data() {
        return {
            id: null,
            name: '',
            logs: [],
            isLoadingData: false
        };
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    methods: {
        formatDuration,
        async openModal({ id, name }) {
            this.id = id;
            this.name = name;
            this.logs = [];
            this.isLoadingData = true;

            this.$nextTick(() => {
                $(this.$refs.modal).modal({
                    backdrop: 'static',
                    keyboard: false
                });
            });

            await this.fetchFollowUpLogs(id);
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
            
            this.id = null;
            this.name = '';
            this.logs = [];
        },
      formatDate(datetime) {
        const date = new Date(datetime);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const datePart = `${day}/${month}/${year}`;
        const timePart = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });

        return `${datePart}<br>${timePart}`;
      },
        async fetchFollowUpLogs(id) {
            try {
                const response = await getFollowUpLogs(id);
                this.logs = response.data.data
                    .sort((a, b) => new Date(b.show_datetime) - new Date(a.show_datetime))
                    .map(log => ({ ...log, formattedDate: this.formatDate(log.show_datetime, log.timezone) }));
            } catch (error) {
                console.error('Failed to fetch follow-up logs:', error);
            } finally {
                this.isLoadingData = false;
            }
        }
    }
};
</script>
